const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="mt-16 px-5 sm:px-10 xl:px-20">
      <div className="flex flex-col items-center justify-center">
        <div className="flex flex-col justify-center items-center">
          <h3 className="lg:text-[32px] text-2xl font-worksans text-[#0E1728]">
            How It Works
          </h3>
          <p className="text-[#464748] font-onestMedium text-lg">
            Whether you’re a sender or a recipient, it’s easy to get started!
          </p>
        </div>
        <div className="flex mt-10 sm:space-y-0 space-y-3 sm:flex-row flex-col">
          <img
            src="images/Container.svg"
            width={"50%"}
            alt="safe-locker"
            className="sm:block hidden"
          />
          <img
            src="images/Container.svg"
            width={"100%"}
                 alt="safe-locker"
            className="sm:hidden block"
          />
          <img
            src="images/Content.svg"
            width={"50%"}
                  alt="safe-locker-content"

            className="sm:block hidden"
          />
          <img
            src="images/Content.svg"
            width={"100%"}
            alt="safe-locker-content"
            className="sm:hidden block -ml-8"
          />
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
